import { current as _current } from '@reduxjs/toolkit'
import React from 'react'
import Color from '@/components/Compare/Color'
import { useAppSelector } from '@/hooks'
import './index.less'

export default function ColorCompare() {
  const fucaiData = useAppSelector((state) => state.compareInfo.colorBar)
  return (
    <div className='compare-color'>
      <Color fucaiData={fucaiData} />
    </div>
  )
}
